import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { handleSignOut } from "../ServiceRequest";
import { Spinner, Text, Stack, Box } from '@chakra-ui/react';
import logo from '../assets/Logo_EssilorLuxottica_black.png';
import '../pages/Login/LoginPage.css'

const SignOut = () => {
  const navigate = useNavigate();

  const [isLoggingOut, setIsLoggingOut] = useState(false);


  const performLogout = async () : Promise<void>=> {
    if (isLoggingOut) return;
    setIsLoggingOut(true);
    try {
      await handleSignOut();
    } catch (err) {
      console.error("Errore durante il logout:", err);
    }
  };

  useEffect(() => {
    performLogout();
  }, [navigate]);

  return (
    <Box className="login-container">
        <Box className="login-box">
            <Stack spacing={4} align="center">
                <img className="logo" src={logo} alt="Logo" style={{ width: '550px', height: 'auto' }} />
                <h1><b>Signing out...</b></h1>
                <Spinner size="xl" />
            </Stack>
        </Box>
    </Box>
);
};

export default SignOut;